import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
    meta: any = { isLoading: false };

    constructor() {
        this.meta.isLoading = false;
    }

    startLoad() {
        this.meta.isLoading = true;
    }

    stopLoad() {
        this.meta.isLoading = false;
    }

}


/** WEBPACK FOOTER **
 ** ./app/common/LoadingService.ts
 **/